import React, { useState } from "react";
import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";
import Form from "react-bootstrap/Form";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";

function KnowledgeCentrePage() {
  const storeToken = localStorage.getItem("ssoToken");
  if (storeToken == null) {
    window.location.replace("/");
    // localStorage.clear("");
  }
  return (
    <>
      <Header />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar/>
      <main id="main-content" className="knowledge">
        <div className="knowledge-header">
          <h2 className="knowledge-header-title">Modules</h2>
          <div className="knowledge-header-option">
            {/* search-bar */}
            <div className="search-box">
              <form action="#" method="post">
                <div className="form-group">
                  <input
                    type="text"
                    name="search-text"
                    className="input-st"
                    placeholder="Search modules by text, keywords, etc..."
                  />
                  <input
                    type="submit"
                    name="submit"
                    value="submit"
                    className="submit-btn"
                  />
                </div>
              </form>
            </div>
            {/* dropdown-filter */}
            <div className="dropdown-filter">
              <Form.Select size="lg" aria-label="Default select example">
                <option value="largecap">English</option>
                <option value="smallcap">Hindi</option>
                <option value="midcap">French</option>
              </Form.Select>
            </div>
            {/* switch tab */}
            <ul
              className="nav nav-tabs filter-tabs"
              id="knowledgeTab"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  id="module-tab"
                  data-toggle="tab"
                  data-target="#module-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="module-tab-pane"
                  aria-selected="true"
                >
                  Modules
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="video-tab"
                  data-toggle="tab"
                  data-target="#video-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="video-tab-pane"
                  aria-selected="false"
                >
                  Videos
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="tab-content refer-tab-content" id="knowledgeTabContent">
          <div
            className="tab-pane fade show active"
            id="module-tab-pane"
            role="tabpanel"
            aria-labelledby="module-tab"
            tabIndex={0}
          >
            <div className="accordion" id="accordionKnowledge">
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingOne">
                  <button
                    className="accordion-button"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    Equity
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  className="accordion-collapse collapse show"
                  aria-labelledby="headingOne"
                  data-parent="#accordionKnowledge"
                >
                  <div className="accordion-body ">
                    <div className="row border-parent">
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="/knowledge-centre" />
                          <h4 className="accordion-card-title">
                            Introduction to Stock Market
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Technical Analysis
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Fundamental Analysis
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Futures Trading
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Theory of Professional Trading
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Option Strategies
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Markets & Taxation
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Currency & Commodity
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Government Securities
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Personal Finance
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Risk Management
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Trading Systems
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTwo">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseTwo"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    Mutual Funds
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingTwo"
                  data-parent="#accordionKnowledge"
                >
                  <div className="accordion-body ">
                    <div className="row border-parent">
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Introduction to Stock Market
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Technical Analysis
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Fundamental Analysis
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Futures Trading
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Theory of Professional Trading
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Option Strategies
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Markets & Taxation
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Currency & Commodity
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Government Securities
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Personal Finance
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Risk Management
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Trading Systems
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingThree">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseThree"
                    aria-expanded="true"
                    aria-controls="collapseThree"
                  >
                    Insurance
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingThree"
                  data-parent="#accordionKnowledge"
                >
                  <div className="accordion-body ">
                    <div className="row border-parent">
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Introduction to Stock Market
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Technical Analysis
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Fundamental Analysis
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Futures Trading
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Theory of Professional Trading
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Option Strategies
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Markets & Taxation
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Currency & Commodity
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Government Securities
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Personal Finance
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Risk Management
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Trading Systems
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingFour">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseFour"
                    aria-expanded="true"
                    aria-controls="collapseFour"
                  >
                    Corporate FD
                  </button>
                </h2>
                <div
                  id="collapseFour"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingFour"
                  data-parent="#accordionKnowledge"
                >
                  <div className="accordion-body ">
                    <div className="row border-parent">
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Introduction to Stock Market
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Technical Analysis
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Fundamental Analysis
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Futures Trading
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Theory of Professional Trading
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Option Strategies
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Markets & Taxation
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Currency & Commodity
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Government Securities
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Personal Finance
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Risk Management
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Trading Systems
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingFive">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseFive"
                    aria-expanded="true"
                    aria-controls="collapseFive"
                  >
                    Bond
                  </button>
                </h2>
                <div
                  id="collapseFive"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingFive"
                  data-parent="#accordionKnowledge"
                >
                  <div className="accordion-body ">
                    <div className="row border-parent">
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Introduction to Stock Market
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Technical Analysis
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Fundamental Analysis
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Futures Trading
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Theory of Professional Trading
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Option Strategies
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Markets & Taxation
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Currency & Commodity
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Government Securities
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Personal Finance
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Risk Management
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                      <div className="col-sm-6 col-lg-4 card-accordian">
                        <div className="accordion-card band">
                          <a href="#" />
                          <h4 className="accordion-card-title">
                            Trading Systems
                          </h4>
                          <p className="accordion-card-subtitle">20 Chapters</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="video-tab-pane"
            role="tabpanel"
            aria-labelledby="video-tab"
            tabIndex={0}
          ></div>
        </div>
      </main>
    </>
  );
}

export default KnowledgeCentrePage;
